import { render, staticRenderFns } from "./DxToolsTable.vue?vue&type=template&id=7e669f45&"
import script from "./DxToolsTable.vue?vue&type=script&lang=js&"
export * from "./DxToolsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports